import React from "react";
import useSpeechInput from "../../hooks/useSpeechInput";
import { TextInput } from "../layout";

function MicButton({ listening, onToggle, supported }) {
  if (!supported) return null;
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={listening ? "Stop listening" : "Start voice input"}
      style={{
        flexShrink: 0,
        width: 36,
        height: 36,
        borderRadius: "50%",
        border: listening ? "2px solid #e53935" : "2px solid #bdbdbd",
        background: listening ? "#ffebee" : "transparent",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        animation: listening ? "pulse 1.2s infinite" : "none",
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24"
        fill={listening ? "#e53935" : "#757575"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
        <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
      </svg>
    </button>
  );
}

export default function SpeechTextInput({ label, type = "text", value, onChange, onSpeechResult, style }) {
  const speechHook = useSpeechInput({ onResult: onSpeechResult });
  const { toggle, listening, supported } = speechHook;

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%   { box-shadow: 0 0 0 0 rgba(229,57,53,0.4); }
          70%  { box-shadow: 0 0 0 8px rgba(229,57,53,0); }
          100% { box-shadow: 0 0 0 0 rgba(229,57,53,0); }
        }
      `}</style>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: style?.marginBottom ?? 0,
        ...style,
      }}>
        <div style={{ flex: 1 }}>
          <TextInput
            label={label}
            type={type}
            value={value}
            onChange={onChange}
            style={listening ? { outline: "2px solid #e53935" } : undefined}
          />
        </div>
        <MicButton listening={listening} onToggle={toggle} supported={supported} />
      </div>
    </>
  );
}